import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from './shared/services/authentication.service';
import { Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { filter } from 'rxjs/operators';
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  constructor(
    private auth: AuthenticationService,
    private router: Router,
    private location: Location,
    private permissionService: NgxPermissionsService
  ) {}

  ngOnInit(): void {
    this.loadPermissions();
    console.log(this.auth.currentUserValue)
  }

  loadPermissions() {
    this.permissionService.loadPermissions(
      JSON.parse(
        atob(this.auth.currentUserValue?.user.role.permission.split('@')[0])
      ).filter((perm: any) => perm != '')
      // JSON.parse(atob('WyJyb290Il0=@'.split('@')[0])).filter(
      //   (perm: any) => perm != ''
      // )
    );

    this.permissionService.permissions$.subscribe((permissions: any) => {

      console.log('permissions', permissions);
    });
  }
}
